import { useId } from "react";

import { BattleCard } from "../../../../domain/battles/BattleCard.js";
import { cn } from "../../../../foundations/cn.js";
import { Section } from "../../../../patterns/Section.js";
import { SectionHeader } from "../../../../patterns/SectionHeader.js";
import type { HomeBattlesContent } from "../../homeContent.js";

/**
 * A few battles from the lobby, each linking to its room; nothing for none. The `grid` variant sets them as
 * cards, up to three across; `rows` lists them down the page, one wide line each.
 */
export function HomeBattles({
  variant = "grid",
  ...battles
}: HomeBattlesContent & { variant?: "grid" | "rows" }) {
  const id = useId();
  if (battles.cards.length === 0) return null;
  const rows = variant === "rows";
  return (
    <Section aria-labelledby={id} className={cn("flex flex-col", rows ? "gap-4" : "gap-6")}>
      <SectionHeader
        title={battles.title}
        titleId={id}
        action={battles.viewAll}
        size={rows ? "sm" : "lg"}
      />
      <ul
        className={cn(
          rows ? "flex flex-col gap-2" : "grid gap-3 md:grid-cols-2 md:gap-5 xl:grid-cols-3",
        )}
      >
        {battles.cards.map(({ id: cardId, ...card }) => (
          <li key={cardId} className="min-w-0">
            <BattleCard {...card} layout={rows ? "row" : "card"} className="h-full" />
          </li>
        ))}
      </ul>
    </Section>
  );
}
